import React, {useContext, useEffect, useRef, useState } from 'react'
import axios from "axios";
import { ErrorMessage, Field, Form, Formik,  } from "formik" ;
import toast from "react-hot-toast";
import * as Yup from 'yup';
import { UserContext } from '../../../Context/UserContext.js';
import Swal from 'sweetalert2';

export default function AddUserAdmin() {
   const [loading , setLoading] = useState(false) ;
   const [showPassword , setShowPassword] = useState(false) ;
   const closeBtnRef = useRef() ;
   
   const {userToken , getTypeUsers , getDataCount} = useContext(UserContext) ;
   const header = {
      token:`${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
   }


   const handleSubmit = async(values, { resetForm }) => {
      setLoading(true);
      await axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/users` , values ,  {headers:header})
      .then(({data})=>{
         if(data.message === "success"){
            setLoading(false);
            toast.success("Added New User Successfully ")
            Swal.fire({
               title: `
                  Name: ${values.name}
                  Email: ${values.email}
                  Password :${values.password}
                  phone: ${values.phone}
                  birthDay: ${values.birthDay}
                  Role: ${values.role}
               `,
               showClass: {
               popup: `
                  animate__animated
                  animate__fadeInUp
                  animate__faster
               `
               },
               hideClass: {
               popup: `
                  animate__animated
                  animate__fadeOutDown
                  animate__faster
               `
               }
            });
            getTypeUsers() ;
            getDataCount() ;
         }
      })
      .catch((error)=>{
         setLoading(false);
         toast.error(error.response?.data.message)
      })
      resetForm();
      closeBtnRef.current.click() ;
   };


   const initialValues = {
      name:"" ,
      phone:"" ,
      email:"" ,
      role:"" ,
      gender:"" ,
      birthDay:"" ,
      password:"" ,
      rePassword:"" 
   };

   const validationSchema = Yup.object({
      name:Yup.string().min(2 , "Name Should be More than 2").max(50 , "Name less than 50").required("Name is Required").trim() ,
      email:Yup.string().email().required().trim() ,
      gender: Yup.string().oneOf(['male', 'female'], 'Required Male or Female').required('Gender Required') ,
      phone:Yup.string().required().trim() ,
      birthDay:Yup.string().required().trim() ,
      role:Yup.string().required() ,
      password:Yup.string().required().matches(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]?).{8,}$/ , "Should be Password Start UpperCase And Contain 8 Character And Contain any (@#$%&*)") ,
      rePassword:Yup.string().oneOf([Yup.ref("password")]  , "rePassword Should be Same Password").required() ,
   });



   useEffect(() => {

   }, [])
   return (
         <div className="AddNewUserAdmin-container">
            <div className="modal fade" id="AddNewUserAdmin" tabIndex="-1" aria-labelledby="AddNewUserAdminLabel" aria-hidden="true">
               <div className="modal-dialog ">
                  <div className="modal-content">

                     <div className="modal-header">
                        <h5 className="modal-title" id="AddNewUserAdminLabel">اضافة مستخدم جديد</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ref={closeBtnRef}></button>
                     </div>

                     <div className="modal-body">
                        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit} enableReinitialize >
                           <Form>

                              <div className="mb-3">
                                 <label className="form-label">الاسم</label>
                                 <Field type="text" name="name" className="form-control" />
                                 <div className="text-danger"><ErrorMessage name="name" /></div>
                              </div>

                              <div className="mb-3">
                                 <label className="form-label">الايميل</label>
                                 <Field type="email" name="email" className="form-control" />
                                 <div className="text-danger"><ErrorMessage name="email" /></div>
                              </div>

                              <div className="mb-3">
                                 <label className="form-label">الموبايل</label>
                                 <Field type="tel" name="phone" className="form-control" />
                                 <div className="text-danger"><ErrorMessage name="phone" /></div>
                              </div>

                              <div className="mb-3">
                                 <label className="form-label d-block">النوع</label>

                                 <div className="form-check form-check-inline">
                                    <Field
                                       type="radio"
                                       name="gender"
                                       value="male"
                                       className="form-check-input"
                                       id="male"
                                    />
                                    <label htmlFor="male" className="form-check-label">male</label>
                                 </div>

                                 <div className="form-check form-check-inline">
                                    <Field
                                       type="radio"
                                       name="gender"
                                       value="female"
                                       className="form-check-input"
                                       id="female"
                                    />
                                    <label htmlFor="female" className="form-check-label">Female</label>
                                 </div>

                                 <div className="text-danger"><ErrorMessage name="gender" /></div>
                              </div>

                              <div className="mb-3">
                                 <label className="form-label">تاريخ الميلاد</label>
                                 <Field type="date" name="birthDay" className="form-control" />
                                 <div className="text-danger"><ErrorMessage name="birthDay" /></div>
                              </div>

                              <div className="mb-3 position-relative">
                                 <label className="form-label">كلمة المرور </label>
                                 <Field type={showPassword ? "text" : "password"}   name="password" className="form-control" />
                                 {showPassword ? (
                                          <i className="fas fa-eye toggle-password " onClick={() => setShowPassword(false)}></i>
                                       ) : (
                                          <i className="fas fa-eye-slash toggle-password " onClick={() => setShowPassword(true)}></i>
                                       )
                                 }
                                 <div className="text-danger"><ErrorMessage name="password" /></div>
                              </div>

                              <div className="mb-3">
                                 <label className="form-label">تأكيد كلمة المرور </label>
                                 <Field type={showPassword ? "text" : "password"}   name="rePassword" className="form-control" />
                                 <div className="text-danger"><ErrorMessage name="rePassword" /></div>
                              </div>

                              <div className="mb-3">
                                 <label className="form-label d-block">الحالة</label>

                                 <div className="form-check form-check-inline">
                                    <Field
                                       type="radio"
                                       name="role"
                                       value="admin"
                                       className="form-check-input"
                                       id="admin"
                                    />
                                    <label htmlFor="admin" className="form-check-label">Admin</label>
                                 </div>

                                 <div className="form-check form-check-inline">
                                    <Field
                                       type="radio"
                                       name="role"
                                       value="moderator"
                                       className="form-check-input"
                                       id="moderator"
                                    />
                                    <label htmlFor="moderator" className="form-check-label">Moderator</label>
                                 </div>

                                 <div className="form-check form-check-inline">
                                    <Field
                                       type="radio"
                                       name="role"
                                       value="user"
                                       className="form-check-input"
                                       id="user"
                                    />
                                    <label htmlFor="user" className="form-check-label">User</label>
                                 </div>

                                 <div className="text-danger"><ErrorMessage name="role" /></div>
                              </div>

                              <div className="d-flex justify-content-end">
                                 {loading ? 
                                       <button className="btn btn-primary"> <i className="fa-solid fa-spinner fa-spin fa-rotate-180 fa-xl"></i></button>
                                    : 
                                       <button type="submit" className="btn btn-primary">اضافة المستخدم</button>
                                 }
                              </div>
                           </Form>
                        </Formik>
                     </div>

                  </div>
               </div>
            </div>
         </div>
      );
}
